import { render, staticRenderFns } from "./CreateDefaultModal.vue?vue&type=template&id=22b58982&scoped=true&lang=pug"
import script from "./CreateDefaultModal.vue?vue&type=script&lang=js"
export * from "./CreateDefaultModal.vue?vue&type=script&lang=js"
import style0 from "./CreateDefaultModal.vue?vue&type=style&index=0&id=22b58982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b58982",
  null
  
)

export default component.exports